export default class SelectAllCheckbox {
  constructor() {
    N2.bindHandler('change', "input[type=checkbox]#select-all", function(e) {
      $(':checkbox').prop('checked', this.checked)
    })
  }

  checkUiStates() {
    if ($("input:checkbox:not(#select-all):checked").length > 0) {
      $('#return-assignments').attr('disabled', false);
      $('#select-assignmnet-text').text('Return Selected Assignments To The Team Queue?')
    } else {
      $('#return-assignments').attr('disabled', true);
      // uncheck #select-all if checked
      $('input[type=checkbox]#select-all').attr('checked', false);
      $('#select-assignmnet-text').text('Select An Assignment To Return To The Team Queue')
    }
  }

  changeBackgroundColor() { 
    $(event.target).not('#select-all').parents('tr').toggleClass('striped-row')

    if ($(event.target).is('#select-all')) {
      // need this in event #select-all is clicked
      // when some rows are striped & some aren't - toggleClass would create issue
      if ($(event.target).is(':checked')) {
        $(':checkbox').not('#select-all').parents('tr').addClass('striped-row')
      } else {
        $(':checkbox').not('#select-all').parents('tr').removeClass('striped-row')
      }
    }
  }
}
